<template>
  <v-dialog
    v-model="dialogDebug"
    @keydown.esc="closeDebug"
    persistent
    scrollable
    content-class="medium"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Conversation detail</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div id="ul-tab" class="pt-0">
            <div
              v-for="(tab, index) in logBotCaller"
              :key="index"
              @click="clickTab(tab.index)"
              class="li-tab menu-title"
              :class="tab.index === tabSelected ? 'selected' : ''"
            >
              <div>Index: {{ tab.index }}</div>
            </div>
          </div>

          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <div class="borderTop1">
                <div v-if="Object.keys(jsonView).length > 0">
                  <json-viewer
                    v-model="jsonView"
                    :expand-depth="4"
                    copyable
                    boxed
                    expanded
                  ></json-viewer>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn id="btn-ok" class="btn-primary" text @click="closeDebug">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'DialogDebug',
  props: {
    dialogDebug: Boolean,
    logBotCaller: Array,
    logBotCallerIndex: Number
  },
  data() {
    return {
      jsonView: {},
      tabSelected: -1
    }
  },
  watch: {
    logBotCaller: {
      immediate: true,
      deep: true,
      handler(val) {
        setTimeout(() => {
          this.tabSelected = this.logBotCallerIndex

          const data = _.find(this.logBotCaller, o => {
            return o.index === this.tabSelected
          })
          this.jsonView = data ? data : {}
        }, 500)
      }
    }
  },
  methods: {
    clickTab(index) {
      this.tabSelected = index

      const data = _.find(this.logBotCaller, o => {
        return o.index === this.tabSelected
      })

      this.jsonView = data
    },
    closeDebug() {
      this.$emit('closeDebug', null)
    }
  }
}
</script>

<style scoped lang="scss">
.borderTop1 {
  height: calc(100vh - 332px);
  overflow-y: scroll;
  background-color: white;
  border: 1px solid;
  border-color: #ebebeb;
  padding: 15px 0px 15px 15px;
}
.width100px {
  width: 100px;
}

#ul-tab {
  display: flex;
  padding: 0px;
  margin: 0px 30px 10px 0px;
  white-space: nowrap;
  overflow-x: hidden;
  overflow-y: hidden;

  .li-tab {
    display: inline-flex;
    padding: 0 10px 0 10px;
    cursor: pointer;

    &:not(:last-of-type) {
      &:after {
        content: '|';
        padding-left: 20px;
        font-weight: 100;
        color: $border-color;
      }
    }

    &:last-of-type {
      padding-right: 20px;
    }

    &.selected {
      font-weight: 700;
      color: $primary !important;
    }
  }

  &:hover {
    overflow-x: overlay;
  }
}
</style>
